export default {
  ITEM_HEIGHT: 50
};
